import React from 'react';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../../ComparisonMetric';
import usePartnersEngagingWithEducators from './usePartnersEngagingWithEducators';

export default function PartnersEngagingWithEducators(props) {
  const { network, schoolStart, schoolEnd, titleOnly = false } = props;

  const title = `(num) # partners who have created an offer OR responded to an invite OR claimed a project`;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousUsers = usePartnersEngagingWithEducators(network, {
    start: titleOnly ? undefined : previousSchoolStart,
    end: schoolStart
  });

  const newUsers = usePartnersEngagingWithEducators(network, {
    start: schoolStart,
    end: schoolEnd
  });

  if (
    previousUsers.state === PayloadStates.FETCHING ||
    newUsers.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name={title}
      />
    );
  }

  return (
    <ComparisonMetric
      name={title}
      value={newUsers.meta.totalCount}
      previousValue={previousUsers.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
